import { useEffect, useState } from "react";
import { useGoalsStore } from "@/apps/goals/store/goalsStore";
import { requestRaffleBonusInit } from "@/apps/raffle/services/raffleApi";
import { useRaffleDataStore } from "@/apps/raffle/store/raffleDataStore";
import { useStartupParamsStore } from "@/store/startupParams";
import { useAppPreloadStore } from "./appPreloadStore";

export const useAppPreload = (search: string) => {
  const [isPreloading, setIsPreloading] = useState(false);
  const storedYandexId = useStartupParamsStore((state) => state.auth.yandexId);
  const yandexId =
    new URLSearchParams(search).get("yandex_id") ?? storedYandexId;
  const loadGoalsData = useGoalsStore((state) => state.loadUserData);
  const cacheRaffle = useRaffleDataStore((state) => state.setRaffle);
  const setBonusWinPopup = useRaffleDataStore(
    (state) => state.setBonusWinPopup
  );
  const preloadRevision = useAppPreloadStore((state) => state.revision);

  useEffect(() => {
    if (!yandexId) return;

    let isCurrentRequest = true;

    const preloadAppData = async () => {
      setIsPreloading(true);

      const raffleInitPromise = requestRaffleBonusInit(yandexId).then(
        (data) => {
          cacheRaffle(yandexId, undefined, data.current_draw);
          setBonusWinPopup(data.bonus_win_popup);
        }
      );

      await Promise.allSettled([loadGoalsData(yandexId), raffleInitPromise]);

      if (isCurrentRequest) {
        setIsPreloading(false);
      }
    };

    preloadAppData();

    return () => {
      isCurrentRequest = false;
    };
  }, [cacheRaffle, loadGoalsData, preloadRevision, setBonusWinPopup, yandexId]);

  return isPreloading;
};
